export default __webpack_public_path__ + "static/media/about-tinc.a6c306b7.png";